export enum PartnerFiltersKey {
  Cities = 'city_id',
  FieldManagers = 'field_manager_id',
  Name = 'name',
  Offices = 'office_id',
  TaxNumber = 'tax_number',
}
